<template>
  <div class="questions">
    <h2 class="title">{{ currentQuestion.title }}</h2>
    <p class="description">{{ currentQuestion.description }}<template v-if="currentQuestion.multiple"><br>(Choix multiple ou continuer)</template></p>
    <template v-if="!currentQuestion.multiple">
      <ul class="answers">
        <li class="btn answer" v-for="answer in currentQuestion.answers" :key="answer.id" @click="onClickAnswer(answer)"><span>{{ answer.text }}</span></li>
      </ul>
    </template>
    <template v-else>
      <ul class="answers">
        <li class="answer -multiple" :class="{ '-active': isInAnswer(answer), '-check': currentQuestion.multiple }" v-for="answer in currentQuestion.answers" :key="answer.id" @click="onClickAnswerMultiple(answer)">
          <span class="checkbox">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14.6" fill="currentColor" xml:space="preserve">
                <path d="M19.1,3.5L8.9,13.8c-0.8,0.8-2,0.8-2.7,0L0.9,8.5c-0.8-0.8-0.8-2,0-2.7c0.8-0.8,2-0.8,2.7,0l3.9,3.9l8.8-8.8
                  c0.8-0.8,2-0.8,2.7,0C19.9,1.6,19.9,2.8,19.1,3.5z"/>
            </svg>
          </span>
          <span class="btn">{{ answer.text }}</span>
        </li>
      </ul>
      <button class="btn btn-next -active" @click="onClickAnswer(currentAnswers)">Continuer</button>
    </template>

  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'Questions',
  props: {},
  data: () => ({
    currentAnswers: []
  }),
  computed: {
    ...mapState([
      'backend',
      'currentStep',
      'currentQuestion',
      'stepPaths',
      'stepOffers'
    ])
  },
  created() {
    if (this.$gtm) {
      this.$gtm.trackEvent(({
        category: 'Steps',
        action: 'click',
        label: this.currentStep + 1
      }))
    }
  },
  watch: {
    currentStep(currentStep) {
      if (this.$gtm) {
        this.$gtm.trackEvent(({
          category: 'Steps',
          action: 'click',
          label: currentStep + 1
        }))
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_CURRENT_QUESTION',
      'SET_RESULTS',
      'NEXT_STEP',
      'ADD_SUMMARY',
      'ADD_STEP_PATHS',
      'ADD_STEP_OFFERS',
      'GOTO_RESULTS'
    ]),
    onClickAnswer(answer) {
      // Multi answer
      let isAnswerMultiple = !!answer.length
      let nextQuestionId = null
      let isResult = false
      // Get paths
      const paths = this.stepPaths[this.currentStep]

      let nextPaths = []
      for (let i=0; i < paths.length; i++) {
        let p = paths[i]
        if (p?.paths[this.currentStep]?.question?.id === this.currentQuestion?.id) {
          for (let j = 0; j < p?.paths[this.currentStep]?.answers.length; j++) {
            // TODO: REFACTO (SORRY I'M NOT REALLY SORRY) !
            if(isAnswerMultiple) {
              for(let a = 0; a < answer.length; a++) {
                if (p?.paths[this.currentStep]?.answers[j]?.answer?.id === answer[a]?.id) {
                  nextPaths.push(p)
                  nextQuestionId = p?.paths[this.currentStep]?.next_question?.id
                  if(p?.paths[this.currentStep]?.answers[j].offers.length > 0) {
                    this.ADD_STEP_OFFERS(p?.paths[this.currentStep]?.answers[j].offers)
                  }
                  isResult = nextQuestionId === this.backend.config.end_question.id
                }
              }
            } else {
              if (p?.paths[this.currentStep]?.answers[j]?.answer?.id === answer?.id) {
                nextPaths.push(p)
                nextQuestionId = p?.paths[this.currentStep]?.next_question?.id
                if(p?.paths[this.currentStep]?.answers[j].offers.length > 0) {
                  this.ADD_STEP_OFFERS(p?.paths[this.currentStep]?.answers[j].offers)
                }
                isResult = nextQuestionId === this.backend.config.end_question.id
              }
            }
          }
        }
      }

      if (!isResult && nextQuestionId) {
        const nextQuestion = this.backend.questions.filter(question => question.id === nextQuestionId)[0]
        this.SET_CURRENT_QUESTION(nextQuestion)
        this.NEXT_STEP()
        this.ADD_STEP_PATHS(nextPaths)
        this.ADD_SUMMARY(this.currentQuestion)
      } else {
        this.GOTO_RESULTS()
      }
    },
    isInAnswer(answer) {
      return this.currentAnswers.filter(a => a.id === answer.id)[0]
    },
    onClickAnswerMultiple(answer) {
      if (this.currentAnswers.filter(a => a.id === answer.id)[0]) {
        this.currentAnswers = this.currentAnswers.filter(a => a.id !== answer.id)
      } else {
        this.currentAnswers.push(answer)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '~@wide/styles-utils' as *;
@import '@/assets/scss/variables';
@import '@/assets/scss/btn';

.questions {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 768px;

  .title {
    display: block;
    width: 100%;
    text-align: center;
  }

  .description {
    display: block;
    width: 100%;
    text-align: center;
  }

  .answers {
    display: flex;
    flex-direction: column;
    margin-top: 4rem;
    width: 100%;

    @include bp-up(md) {
      width: auto;
    }

    .answer {
      margin-bottom: 1rem;

      &.-multiple {
        display: flex;
        justify-content: center;
        align-items: center;

        .checkbox {
          flex: 0 0 2.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 2.5rem;
          height: 2.5rem;
          border: 1px solid $white;
          border-radius: 0.5rem;
          margin-right: 2rem;

          svg {
            display: none;
            width: 1.7rem;
            height: 1.7rem;
            fill: $blue;
          }
        }

        .btn {
          flex: 1;
        }

        &.-active {
          .checkbox {
            background-color: $white;

            svg {
              display: block;
            }
          }

          .btn {
            background: $blue;
            color: $white;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .btn-next {
    margin-top: 4rem;
  }
}

</style>
